module.exports = __webpack_public_path__ + "static/img/role-pt.9e993ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-pt.png
// module id = lWMa
// module chunks = 1